import { render, staticRenderFns } from "./cpt-num.vue?vue&type=template&id=793fe702&scoped=true"
import script from "./cpt-num.vue?vue&type=script&lang=js"
export * from "./cpt-num.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "793fe702",
  null
  
)

export default component.exports